import React, { useState, useEffect } from "react";
import './PerfilEmpresa.css';

import PerfilEmpresa1 from '../../assets/About/PerfilEmpresa/perfilEmpresa.png';
import PerfilEmpresa2 from '../../assets/About/PerfilEmpresa/PerfilEmpresa2.png';
import PerfilEmpresa3 from '../../assets/About/PerfilEmpresa/PerfilEmpresa3.png';
import PerfilEmpresa4 from '../../assets/About/PerfilEmpresa/PerfilEmpresa4.png';
import PerfilEmpresa5 from '../../assets/About/PerfilEmpresa/PerfilEmpresa5.png';
import perfilEmpresaMobile from '../../assets/About/PerfilEmpresa/perfilEmpresaMobile.png';
import pe40 from '../../assets/About/PerfilEmpresa/pe40.png';
import pe100 from '../../assets/About/PerfilEmpresa/pe100.png';



// Swiper imports
// Swiper imports
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

function PerfilEmpresa() {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const items = [
        {
            img: PerfilEmpresa2,
            text: (
                <>
                    Además, es reconocida como <span style={{ color: "#cc2f39" }}> Centro Técnico de Materiales de Sellado Anticorrosivo para la Industria Nacional del Petróleo y el Gas, Centro de Investigación Técnica de Ingeniería de Selladores en Henan, Centro Técnico Provisional de Empresas, Estación de Trabajo Académica de Materiales de Sellado y Estación de Trabajo Postdoctoral del Centro de Investigación Científica.</span>
                    <br /><br />
                    Galardonada con el premio "Estrella Empresarial" en varias ocasiones por el gobierno, se distingue por su avanzado sistema de gestión y sus notables beneficios.
                    <br /><br />
                    La empresa ha obtenido las certificaciones <span style={{ color: "#cc2f39" }}>ISO 9001 y TS 16949 </span > del Sistema de Gestión de Cualificaciones, así como la certificación ISO 14001 del Sistema Ambiental.
                    <br /><br />
                    Su Centro de Inspección de Calidad ha obtenido la certificación de la CNAS.
                </>
            ),
            imgLeft: true,
        },
        {
            img: PerfilEmpresa3,
            text: (
                <>
                    Con un <span style={{ color: "#cc2f39" }}>equipo científico y de inspección profesional de más de 100 investigadores, la empresa ha participado y establecido más de 60 estándares nacionales e industriales, y ha declarado más de 70 invenciones nacionales y nuevas patentes.</span>
                    <br /><br />
                    Actualmente, el centro de investigación posee varios laboratorios de inspección profesionales con más de <span style={{ color: "#cc2f39" }}>300 tipos de equipos.</span>
                    <br /><br />
                    Como pionera y líder en la industria nacional de selladores, la empresa ha emprendido y completado varios proyectos del <span style={{ color: "#cc2f39" }}>"Plan Torch" y "Programas para Abordar Problemas Clave"</span>, que han llenado el vacío de la industria de selladores en China.
                    <br /><br />
                    Se ha hecho una gran contribución a la industria de selladores en China.
                </>
            ),
            imgLeft: false,
        },
        {
            img: PerfilEmpresa4,
            text: (
                <>
                    Los productos de la compañía cubren varias series, incluyendo polisulfuro, silicona, butilo, epoxi, poliuretano y recubrimientos, que <span style={{ color: "#cc2f39" }}>se han aplicado ampliamente en muros cortina de construcción, anticorrosión, automóviles, módulos fotovoltaicos de energía solar, LED y fines militares. A un nivel de clase mundial, todos los productos han pasado la Norma Europea y la evaluación de logros afiliada a una nación, provincia o ministerio. Como un excelente sustituto de productos importados, nuestro sellador se ha ampliamente utilizado en decenas de miles de proyectos nacionales e internacionales notables, como el Teatro Nacional, el Aeropuerto Internacional de Pekín, el Museo Nacional, el Pabellón de China de la Expo Mundial, el Centro de la Bolsa de Valores de Shenzhen, el Centro de Shanghái, el Puente Hong Kong-Zhuhai-Macao, el puente sobre el mar en la Bahía de Hangzhou, la Mansión Rolex en Dubái y la Mansión COCOON en Japón. Algunas empresas famosas como Fuyao Group, Zhengzhou Yutong Bus, Lee Chang Yung Chemical Industry y Sinopec Yangze Petrolchemical Company Ltd ya han adoptado nuestros productos.</span>
                    <br /><br />
                </>
            ),
            imgLeft: true,
        },
        {
            img: PerfilEmpresa5,
            text: (
                <>
                    <span style={{ color: "#cc2f39" }}>Actualmente, la empresa cuenta con siete sucursales en Pekín, Shenyang, Shanghái, Suzhou, Shenzhen, Chengdu y Zhongnan </span>, así como más de 40 oficinas de enlace en todo el país. Asimismo, se fundó el departamento de comercio exterior con oficinas de enlace en Hong Kong y Düsseldorf (Alemania). <span style={{ color: "#cc2f39" }}>Los productos de la empresa se venden en más de 40 países y regiones, como Estados Unidos, Japón, Italia, Corea del Sur, Reino Unido, Dubái, Rusia, Australia, Kazajistán e India.</span>
                    <br /><br />
                    De hecho, nuestra marca "SILANDE" se ha consolidado como una marca reconocida en la industria de selladores, tanto en China como en el extranjero.
                </>
            ),
            imgLeft: false,
        }
    ];

    return (
        <>
            <div className="perfil-empresa-container">
                {!isMobile ? (
                    <>
                        <p>
                            Zhengzhou Zhongyuan Silande High Technology Co., Ltd. fue fundada en 1983 y prosperó como la primera empresa de alta tecnología especializada en la investigación, producción y venta de selladores. Como empresa líder en la industria de selladores, fue una de las primeras empresas dedicadas a la producción y venta de selladores estructurales de silicona, designada por el Comité Nacional Económico y Comercial.
                        </p>
                        <img src={PerfilEmpresa1} alt="Perfil Empresa" className="perfil-empresa-img" />
                    </>
                ) : (
                    // <div>
                    //     <div className="perfil-mobile-layout">
                    //         <div className="pe-block">
                    //             <img src={pe40} alt="PE 40" className="perfil-empresa-img-mobile1" />
                    //             <p className="pe-text">Más de 40 años de experiencia en la industria</p>
                    //         </div>
                    //         <div className="pe-block">
                    //             <img src={pe100} alt="PE 100" className="perfil-empresa-img-mobile2" />
                    //             <p className="pe-text">Participación y formulación de más de 100 estándares nacionales e industriales</p>
                    //         </div>
                    //     </div>
                    //     <div className="perfil-mobile-layout">
                    //         <div className="pe-block">
                    //             <img src={pe100} alt="PE 40" className="perfil-empresa-img-mobile2" />
                    //             <p className="pe-text">Contamos con cientos de investigadores científicos</p>
                    //         </div>
                    //         <div className="pe-block">
                    //             <img src={pe40} alt="PE 100" className="perfil-empresa-img-mobile1" />
                    //             <p className="pe-text">Productos exportados a más de 40 países en todos los continentes</p>
                    //         </div>
                    //     </div>
                    // </div>

                    <div>
                        <img src={perfilEmpresaMobile} alt="Perfil Empresa" className="perfil-empresa-img-mobile" />
                    </div>
                )}
            </div>

            {isMobile ? (
                // Carrusel Swiper para mobile
                <Swiper
                    modules={[Pagination, Autoplay]}
                    spaceBetween={20}
                    slidesPerView={1}
                    pagination={{ clickable: true }}
                    autoplay={{
                        delay: 5000,
                        disableOnInteraction: false,
                    }}
                >
                    {items.map(({ img, text }, index) => (
                        <SwiperSlide key={index}>
                            <img src={img} alt={`Perfil Empresa ${index + 2}`} className="perfil-empresa-img-mobile" />
                            <p className="text-mobile">{text}</p>
                        </SwiperSlide>
                    ))}
                </Swiper>
            ) : (
                // Layout desktop original
                <>
                    {items.map(({ img, text, imgLeft }, index) => (
                        <div key={index} className="image-text-container">
                            {imgLeft && <img src={img} alt={`Perfil Empresa ${index + 2}`} className="perfil-empresa-img-left" />}
                            <p className="text-right">{text}</p>
                            {!imgLeft && <img src={img} alt={`Perfil Empresa ${index + 2}`} className="perfil-empresa-img-right" />}
                        </div>
                    ))}
                </>
            )}
        </>
    );
}

export default PerfilEmpresa;
